export type NonbusinessGroup = {
  /** The ID of the nonbusiness group */
  id: number;
  /** The name of the nonbusiness group */
  name: string;
  /** Whether this is the company default group */
  companyDefault: boolean;
};
